import { cva } from '@/styled-system/css';

export const sliderHandleRecipe = cva({
  base: {
    position: 'absolute',
    width: 'handle.md',
    height: 'handle.md',
    background: {
      base: 'Slider.Handle.bg.default',
      _focus: 'Slider.Handle.bg.active',
      _hover: 'Slider.Handle.bg.hover',
      _active: 'Slider.Handle.bg.pressed',
    },
    borderColor: {
      base: 'Slider.Handle.border.default',
      _hover: 'Slider.Handle.border.hover',
      _active: 'Slider.Handle.border.pressed',
      _focus: 'Slider.Handle.border.active',
    },
    borderStyle: 'solid',
    borderWidth: { base: 'Slider.Handle' },
    borderRadius: { base: 'shape.ellipse' },
    boxShadow: { base: 'Slider.Handle.default' },
    _hover: {
      boxShadow: 'Slider.Handle.hover',
    },
    _focus: {
      'zIndex': 2,
      'focusOutline': true,
      '&:is(:hover)': {
        borderColor: { base: 'Slider.Handle.border.activeHover' },
        background: { base: 'Slider.Handle.bg.activeHover' },
      },
      '&:is(:active)': {
        borderColor: { base: 'Slider.Handle.border.activePressed' },
        background: { base: 'Slider.Handle.bg.activePressed' },
      },
    },
  },
  variants: {
    reverse: {
      true: { transform: 'translateX(50%)' },
      false: { transform: 'translateX(-50%)' },
    },
    disabled: {
      true: {
        pointerEvents: 'none',
      },
      false: {
        cursor: 'grab',
        _active: {
          cursor: 'grabbing',
        },
      },
    },
  },
});
